import { Distance, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * This command moves one or more items by a given distance.
 *
 * @class MoveItemsCommand
 * @extends AbstractCommand
 */
export default class MoveItemsCommand extends AbstractCommand {
    /**
     * Creates a new move items command
     *
     * @param {ItemInterface|ItemInterface[]} items Item or array of items
     * @param {Distance} [distance] Distance object
     */
    constructor(items, distance = new Distance(0, 0)) {
        super();
        this.items = Array.isArray(items) ? items : [items];
        this.initialPositions = {};
        this.distance = distance;

        this.items
            .filter(item => item.supportsMove)
            .forEach(item => (this.initialPositions[item.cid] = item.get('position').clone()));
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        let valid = this.items.length && this.distance.getDistance();
        if (this.items.length === 1 && !this.items[0].supportsMove) {
            valid = false;
        }
        return valid;
    }

    /**
     * Set distamce
     *
     * @param {Distance} distance
     */
    setDistance(distance) {
        this.distance = distance;
    }

    /**
     * Execute command
     */
    execute() {
        // do not check validity, because command is being executed while drag and drop all the time

        this.items.forEach((item) => {
            if (item.supportsMove) {
                item.set('position', this.initialPositions[item.cid].clone().move(this.distance));
            }
        });
    }

    /**
     * Unexecute command
     */
    unexecute() {
        // do not check validity, because command is being executed while drag and drop all the time

        this.items.forEach((item) => {
            if (item.supportsMove) {
                item.set('position', this.initialPositions[item.cid]);
            }
        });
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Move ${this.items.length > 1 ? 'items' : this.items[0].attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.MoveItemsCommand = MoveItemsCommand;
